var gl = require('gl-matrix');

module.exports = {
    projection: 0,
    manualRotation: gl.quat.create(),
    videoObjectURL: null
};



/** WEBPACK FOOTER **
 ** ./source/webgl/settings.js
 **/